define( 'templates/invoice-templates',['templates/template-builder'], function(TemplateBuilder) {
    var templateBuilder = new TemplateBuilder();
    
    return {
        /**
         * HEADERS -------------------------------------------------------
         */
        'headers' : {
            // Sortable
            'creationDate' : templateBuilder.sortableHeader('creationDate', 'Date', 'creationTime'),
            'toDate' : templateBuilder.sortableHeader('toDate', 'To', 'toTime'),
            'communicationPrice' : templateBuilder.sortableHeader('communicationPrice', 'Communication price (€)', 'communicationPrice'),
            'fixedPrice' : templateBuilder.sortableHeader('fixedPrice', 'Fixed price (€)', 'fixedPrice'),
            // Basic
            'totalPrice' : templateBuilder.basicHeader('totalPrice', 'Total price (€)'),
            'contract' : {
                'nodeType':'switch_case',
                'switchCaseField': '${global}',
                'switchCase': {
                    'true': templateBuilder.basicHeader('contract', 'Quote number'),
                    'false': null
                }
            },
            'clientName' : {
                'nodeType':'switch_case',
                'switchCaseField': '${global}',
                'switchCase': {
                    'true': templateBuilder.basicHeader('clientName', 'Client'),
                    'false': null
                }
            }, 
            'fromDate' : templateBuilder.basicHeader('fromDate', 'From'),
            'timezone' : templateBuilder.basicHeader('timezone', 'Timezone'),
            'details' : templateBuilder.basicHeader('details', 'Details'),
            'maxTokens' : templateBuilder.basicHeader('maxTokens', 'Max nb of devices'),
            'tokensInUse' : templateBuilder.basicHeader('tokensInUse', 'Activated devices'),
            'invoiced' : templateBuilder.basicHeader('invoiced', 'Invoiced')
        },
        
        /**
         * DATA TEMPLATES -------------------------------------------------------
         */
        'templates' : {
            'contract' : { 
                'nodeType':'switch_case',
                'switchCaseField': '${global}',
                'switchCase': {
                    'true': templateBuilder.linkNode('${contractUrl}', '${contractName}'),
                    'false': null
                }
            },
            'clientName' : { 
                'nodeType':'switch_case',
                'switchCaseField': '${global}',
                'switchCase': {
                    'true': templateBuilder.basicNode('${clientName}'),
                    'false': null
                }
            },
            'creationDate' : templateBuilder.basicNode('${creationDate}'),
            'fromDate' : templateBuilder.basicNode('${fromDate}'),
            'toDate' : templateBuilder.basicNode('${toDate}'),
            'timezone' : templateBuilder.basicNode('${timezone}'),
            'communicationPrice' : templateBuilder.basicNode('${communicationPrice}'),
            'totalPrice' : templateBuilder.basicNode('${totalPrice}'),
            'fixedPrice' : templateBuilder.basicNode('${fixedPrice}'),
            'details' : templateBuilder.linkNode('${url}', 'Details'),
            'maxTokens' : templateBuilder.basicNode('${maxTokens}'),
            'tokensInUse' : templateBuilder.basicNode('${tokensInUse}'),
            'invoiced' : templateBuilder.booleanNode('${invoiced}')
        } // end templates data
    }; // end return
});



